
import listArrange from '@/components/temporary/list-arrange'

import listHeader from '@/components/temporary/list-header'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template';
import Badge from 'vux/src/components/badge/index.vue'


export default {
name: "complaintTp",
data() {
return {
listHeaderTemplateBoard: {},
listArrange: [],
approvalTemplateBoard: {}
}
},
props: ['data','userType'],
created() {
let templateData = this.data;
if(this.userType == 1){
this.listHeaderTemplateBoard = {
template: listHeaderTemplate.complaint,
data() {
return {
title: [templateData.supplierName],
}
}
};
this.listArrange = [
{
icon: "fa fa fa-th-large font-size-mr",
span: 8,
templateBoard: {
template: "<span>账号数量 {{purorgName}}</span>",
data() {
return {
purorgName: templateData.accountQuantity
}
},
}
},
];
}else {
this.listHeaderTemplateBoard = {
template: listHeaderTemplate.contractQueryV3,
data() {
return {
title: [templateData.login,templateData.personName],
}
}
};
this.listArrange = [
{
icon: "fa fa fa-th-large font-size-mr",
span: 14,
templateBoard: {
template: "<span>{{purorgName}}</span>",
data() {
return {
purorgName: templateData.email
}
},
}
},
{
icon: "fa fa fa-th-large font-size-mr",
span: 10,
templateBoard: {
template: "<span>{{purorgName}}</span>",
data() {
return {
purorgName: templateData.phone
}
},
}
},
];
this.approvalTemplateBoard = {
template: listHeaderTemplate.accountStatus,
data() {
return {
status: templateData.activated
}
},
components: {
Badge
}
}
}

},
methods: {},
components: {
listArrange,

divSpan,
listHeaderTemplate,
listHeader
}
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/accountTp.vue